import LambdaFetch from './FetchFromLambda';

export async function listComments(module, recordKey, credentials) {
  const qs = `module=${encodeURIComponent(module)}&recordKey=${encodeURIComponent(JSON.stringify(recordKey))}`;
  const res = await LambdaFetch(
    `comments?${qs}`,
    'get',
    credentials.user.accessToken,
    null,
    '',
    credentials
  );
  return res?.data || [];
}

export async function addComment(module, recordKey, text, credentials) {
  return LambdaFetch(
    'comments',
    'post',
    credentials.user.accessToken,
    JSON.stringify({ module, recordKey, text }),
    'Comment added',
    credentials
  );
}

export async function editComment(module, recordKey, commentId, text, credentials) {
  return LambdaFetch(
    'comments',
    'put',
    credentials.user.accessToken,
    JSON.stringify({ module, recordKey, commentId, text }),
    'Comment updated',
    credentials
  );
}

export async function deleteComment(module, recordKey, commentId, credentials) {
  return LambdaFetch(
    'comments',
    'delete',
    credentials.user.accessToken,
    JSON.stringify({ module, recordKey, commentId }),
    'Comment deleted',
    credentials
  );
}
